import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import MainNav from 'components/MainNav';
import SupportingMenu from 'components/SupportingMenu';
import MobileMenu from 'components/MobileMenu';

import hamburger from 'assets/hamburger.svg';
import cross from './cross.svg';
import staticLogo from 'assets/logo.svg';
import './Header.scss';

const Icon = ({ onClick, isActiveOnMobile }) => {
    const hamburgerIcon = (<div className="col mobile hamburger" onClick={onClick}>
        <img alt="Toggle menu" src={hamburger} />
    </div>);

    const crossIcon = (<div className="col mobile cross" onClick={onClick}>
        <img alt="Close menu" src={cross} />
    </div>);

    return isActiveOnMobile ? crossIcon : hamburgerIcon;
};

const Logo = ({
    logo,
    logoMobile,
    isVisible,
    title,
    logoLink,
}) => {
    return (
        <div className="logo-col">
            {isVisible && (
                <a className="logo" href={logoLink} title={title}>
                    <img src={logo} alt="AF Gruppen" className="logo-image-desktop" />
                    <img src={logoMobile} alt="AF Gruppen" className="logo-image-mobile" />
                </a>
            )}
        </div>
    );
};

Logo.propTypes = {
    logo: PropTypes.string.isRequired,
    logoMobile: PropTypes.string.isRequired,
    isVisible: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    logoLink: PropTypes.string.isRequired,
};

class Header extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            isActive: null,
            isActiveOnMobile: false,
            scrollDown: false,
            lastScrollTop: 0
        };

        this.onClick = this.onClick.bind(this);
        this.activeOnMobile = this.activeOnMobile.bind(this);
        this.updateDimensions = this.updateDimensions.bind(this);
        this.handleTopHeader = this.handleTopHeader.bind(this);
        this.closeCurtain = this.closeCurtain.bind(this);
    }

    static propTypes = {
        header: PropTypes.object,
        searchLink: PropTypes.string,
        inputPlaceholder: PropTypes.string,
        languages: PropTypes.arrayOf(PropTypes.shape({
            isActive: PropTypes.bool.isRequired,
            link: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired,
        })).isRequired,
        startpageLinkLabel: PropTypes.string.isRequired,
        logoImageUrl: PropTypes.string,
        logoImageUrlMobile: PropTypes.string,
        logoLink: PropTypes.string.isRequired,
        searchLabel: PropTypes.string.isRequired,
        closeMenuLabel: PropTypes.string.isRequired,
        openQuickSearchFormBtnAriaLabel: PropTypes.string.isRequired,
        closeQuickSearchFormBtnAriaLabel: PropTypes.string.isRequired,
    }

    componentDidMount() {
        var frontPage = document.getElementsByClassName('fullscreen-list');

        this.updateDimensions();
        (typeof window !== 'undefined') && window.addEventListener("resize", this.updateDimensions);
        (typeof window !== 'undefined') && window.addEventListener("scroll", this.handleTopHeader);

        (typeof window !== 'undefined') && (typeof frontPage[0] !== 'undefined') && frontPage[0].addEventListener('scroll', () => {
            this.handleTopHeader(frontPage[0]);
        });
    }

    componentWillUnmount() {
        (typeof window !== 'undefined') && window.removeEventListener("resize", this.updateDimensions);
        (typeof window !== 'undefined') && window.removeEventListener("scroll", this.handleTopHeader);
    }

    updateDimensions() {
        if((typeof window !== 'undefined') && window.innerWidth > 1024) {
            this.setState({ isActiveOnMobile: false });
        }
    }

    handleTopHeader(e) {
        let st;
        const bodyClass = "header-is-hidden";
        if (e.currentTarget == window){
            st = window.pageYOffset || document.documentElement.scrollTop;
        }else{
            st = e.scrollTop;
        }

        if (st > 70 && st > this.state.lastScrollTop){
            this.setState({"scrollDown": true});
            document.body.classList.add(bodyClass);
        }
        else{
            this.setState({"scrollDown": false});
            document.body.classList.remove(bodyClass);
        }

        setTimeout(() => this.setState({"lastScrollTop": st <= 0 ? 0 : st}), 100); //IE11 always returns the same numbers so needs some delay
        
    }

    onClick(id, callback = null) {
        this.setState({ isActive: this.state.isActive === id ? null : id }, callback);
    }

    closeCurtain() {
        this.setState({ isActive: null, isActiveOnMobile: false });
    }

    activeOnMobile() {
        this.setState({ isActiveOnMobile: !this.state.isActiveOnMobile });
    }

    _handleCurtainClick = e => {
        if (e.target === e.currentTarget) {
            this.setState({ isActive: null });
        }
    }

    render() {
        const {
            header,
            searchLink,
            languages,
            startpageLinkLabel,
            searchLabel,
            inputPlaceholder,
            logoImageUrl,
            logoImageUrlMobile,
            logoLink,
            closeMenuLabel,
            openQuickSearchFormBtnAriaLabel,
            closeQuickSearchFormBtnAriaLabel
        } = this.props;

        const { isActive } = this.state;

        const withCustomLogo = logoImageUrl || logoImageUrlMobile;

        const topHeaderClassNames = classnames('top-header', {
            'mobile': this.state.isActiveOnMobile,
            'with-custom-logo': withCustomLogo
        });

        const headerClassNames = classnames('site-header', {
            'scroll-down': this.state.scrollDown,
            'activeMobile': this.state.isActiveOnMobile,
            'active': this.state.isActive,
        });

        const logo = logoImageUrl ? logoImageUrl : (logoImageUrlMobile ? logoImageUrlMobile : staticLogo);
        const logoMobile = logoImageUrlMobile ? logoImageUrlMobile : (logoImageUrl ? logoImageUrl : staticLogo);

        return (
            <header className={headerClassNames}>
                {isActive !== null && (
                    <div className="header-curtain" onClick={this._handleCurtainClick} />
                )}
                <div className={topHeaderClassNames}>
                    <div className="top-header-wrapper">
                        <div className="top-header-content">
                            {/* BE: Custom logo recommended size is 346x100px */}
                            <Logo
                                logo={logo}
                                logoMobile={logoMobile}
                                isVisible={true}
                                title={startpageLinkLabel}
                                logoLink={logoLink}
                            />
                            <Icon
                                onClick={this.activeOnMobile}
                                isActiveOnMobile={false}
                            />
                            <MainNav
                                menu={header.menu}
                                onClick={this.onClick}
                                isActiveOnMobile={false}
                                isActive={this.state.isActive}
                                closeMenuLabel={closeMenuLabel}
                            />
                            <SupportingMenu
                                menu={header.supportingMenu}
                                searchLink={searchLink}
                                searchLabel={searchLabel}
                                languages={languages}
                                onClick={this.onClick}
                                isActiveOnMobile={false}
                                isActive={this.state.isActive}
                                inputPlaceholder={inputPlaceholder}
                                withCustomLogo={withCustomLogo ? true : false}
                                openQuickSearchFormBtnAriaLabel={openQuickSearchFormBtnAriaLabel}
                                closeQuickSearchFormBtnAriaLabel={closeQuickSearchFormBtnAriaLabel}
                            />
                        </div>
                    </div>
                </div>
                <MobileMenu
                    closeMenu={this.closeCurtain}
                    open={this.state.isActiveOnMobile}
                    searchLabel={searchLabel}
                    searchLink={searchLink}
                    languages={languages}
                    withCustomLogo={withCustomLogo ? true : false}
                    openQuickSearchFormBtnAriaLabel={openQuickSearchFormBtnAriaLabel}
                    closeQuickSearchFormBtnAriaLabel={closeQuickSearchFormBtnAriaLabel}
                    {...header}
                />
            </header>
        );
    }
}

const HeaderPropConverter = ({
    header,
    languages,
    searchLink,
    startpageLinkLabel,
    searchLabel,
    inputPlaceholder,
    logoImageUrl,
    logoImageUrlMobile,
    logoLink,
    closeMenuLabel,
    openQuickSearchFormBtnAriaLabel,
    closeQuickSearchFormBtnAriaLabel
}) => {
    let newHeaderProps = {
        menu: [],
        supportingMenu: header.supportingMenu
    };

    {header.menu && header.menu.map((num, i) => {
        const {...rest } = header.menu[i];
        const link = num.link;
        const linkText = num.linkText;
        let columns = [];

        ['first', 'second', 'third', 'fourth'].forEach(key => {
            if (rest[`${key}Column`] && rest[`${key}Column`].subMenuBlock) {
                columns.push(rest[`${key}Column`].subMenuBlock);
            }
        });
        
        newHeaderProps.menu.push({
            link,
            linkText,
            columns
        });
    });
    }

    return (
        <Header
            header={newHeaderProps}
            languages={languages}
            searchLink={searchLink}
            startpageLinkLabel={startpageLinkLabel}
            searchLabel={searchLabel}
            inputPlaceholder={inputPlaceholder}
            logoImageUrl={logoImageUrl}
            logoImageUrlMobile={logoImageUrlMobile}
            logoLink={logoLink}
            closeMenuLabel={closeMenuLabel}
            openQuickSearchFormBtnAriaLabel={openQuickSearchFormBtnAriaLabel}
            closeQuickSearchFormBtnAriaLabel={closeQuickSearchFormBtnAriaLabel}
        />
    );
};

HeaderPropConverter.propTypes = {
    header: PropTypes.object.isRequired,
    languages: PropTypes.array.isRequired,
    searchLink: PropTypes.string.isRequired,
    startpageLinkLabel: PropTypes.string.isRequired,
    searchLabel: PropTypes.string.isRequired,
    inputPlaceholder: PropTypes.string,
    logoImageUrl: PropTypes.string,
    logoImageUrlMobile: PropTypes.string,
    logoLink: PropTypes.string.isRequired,
    closeMenuLabel: PropTypes.string.isRequired,
    openQuickSearchFormBtnAriaLabel: PropTypes.string.isRequired,
    closeQuickSearchFormBtnAriaLabel: PropTypes.string.isRequired
};

export default HeaderPropConverter;



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx